import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';

function ImportModal({ show, handleShow, onImport, loading }) {
  const [selectedCompany, setSelectedCompany] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  
  let companyOptions = [];
  const companiesStr = localStorage.getItem('companies');
  if (companiesStr) {
    try {
      const companies = JSON.parse(companiesStr);
      if (Array.isArray(companies) && companies.length > 0) {
        companyOptions = companies.map(c => ({
          value: c.id,
          label: c.company_name
        }));
      }
    } catch (e) {
      companyOptions = [];
    }
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check file type
      const allowedTypes = [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/csv'
      ];
      
      if (!allowedTypes.includes(file.type)) {
        toast.error('Please select a valid Excel or CSV file');
        return;
      }
      
      // Check file size (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        toast.error('File size must be less than 10MB');
        return;
      }
      
      setSelectedFile(file);
    }
  };

  const handleImport = () => {
    if (!selectedCompany || selectedCompany === 0) {
      toast.error('Please select a company');
      return;
    }
    
    if (!selectedFile) {
      toast.error('Please select a file to import');
      return;
    }
    
    onImport(selectedFile, selectedCompany);
  };

  const handleClose = () => {
    setSelectedCompany(0);
    setSelectedFile(null);
    handleShow();
  };

  if (!show) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Import Data</h5>
            <button type="button" className="btn-close" onClick={handleClose}></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label fw-bold">Select Company *</label>
              <Select
                options={companyOptions}
                isSearchable
                placeholder="Select a company..."
                value={companyOptions.find(option => option.value === selectedCompany)}
                onChange={option => setSelectedCompany(option?.value || 0)}
              />
            </div>
            
            <div className="mb-3">
              <label className="form-label fw-bold">Select File *</label>
              <input
                type="file"
                className="form-control"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={handleFileChange}
                disabled={loading}
              />
              <small className="text-muted">
                Supported formats: Excel (.xlsx, .xls) and CSV files. Max file size: 10MB
              </small>
            </div>
            
            {selectedFile && (
              <div className="mb-3">
                <div className="alert alert-info">
                  <strong>Selected File:</strong> {selectedFile.name}<br/>
                  <strong>Size:</strong> {(selectedFile.size / 1024 / 1024).toFixed(2)} MB<br/>
                  <strong>Type:</strong> {selectedFile.type || 'Unknown'}
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={handleClose} disabled={loading}>
              Cancel
            </button>
            <button 
              type="button" 
              className="btn btn-primary" 
              onClick={handleImport}
              disabled={loading || !selectedCompany || !selectedFile}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Importing...
                </>
              ) : (
                'Import'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImportModal;
